(() => {
    window.Dashboard = Dashboard || {};

    window.Dashboard.Models = Dashboard.Models || {};
    window.Dashboard.Models.Lookups = Dashboard.Models.Lookups || {};

    /**
     * Lookup for campaign actions
     * @constructor
     */
    window.Dashboard.Models.Lookups.CampaignTemplateManageOrder = {
        "manage": 1,
        "stores": 2,
        "vouchers": 3,
        "comms": 4,
        "menuscripts": 5,
        "confirm": 6,
    };
})();
